// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1G2L2","toggleWrap":"styles_toggleWrap__1k5Sz","content":"styles_content__2H62A","selectAreaCode":"styles_selectAreaCode__x4Zhf"};